// css
import "../../scss/pages/archive-news.scss";

// utils
import foundation from "../_utils/foundation";
foundation();

// libs
import HeaderSideNav from "../_libs/HeaderSideNav";
import News from "../_libs/News";

document.addEventListener("DOMContentLoaded", () => {
	HeaderSideNav();
	setTimeout(function () {
		document.querySelectorAll(".js-first-animation").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 200);
	News();
});
window.addEventListener("load", () => {});
